var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 2C12.7 2 2 12.7 2 26s10.7 24 24 24 24-10.7 24-24S39.3 2 26 2m2 5.1h-.2zM26 45C15.5 45 7 36.5 7 26c0-1 .1-2.1.3-3 1.3.2 2.9.7 3.7 1.5 1.7 1.8 3.6 3.9 5.4 4.3 0 0-.2.1-.4.4s-.4.9-.4 1.9c0 4.7 4.4 1.9 4.4 6.6s5.3 6.6 5.3 2.8 3.5-5.6 3.5-8.5-2.7-2.8-4.4-3.8c-1.8-.9-2.7-2.4-6.1-1.9-1.8-1.7-2.8-3.1-2-4.7.9-1.7 4.6-2 4.6-4.6s-2.5-3.1-4.3-3.1c-.8 0-2.5-.6-3.9-1.3 1.7-1.7 3.8-3.1 6-4.1 1.6.7 4.3 1.8 6.6 1.8 2.7 0 4.1-1.9 3.7-3.1 4.5.7 8.5 3 11.4 6.2-1.5.9-3.5 1.9-7 1.9-4.6 0-4.6 4.7-1.9 5.6 2.8.9 5.6-1.8 6.5 0s-6.5 1.8-4.6 6.4 3.7-.1 5.6 4.5 5.6-.7 2.8-4.3c-1.2-1.6-.9-6.5 1.9-6.5h.9c.4 1.6.7 3.3.7 5C45 36.5 36.5 45 26 45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.e0ebc2e612025cae201f9e41897d72ed.svg";
export { ForwardRef as ReactComponent };